import { fetchStringToFile } from './fetchStringToFile'

export async function download(url: string, filename: string) {
  const file = await fetchStringToFile(url, filename)
  const link = document.createElement('a')
  link.href = URL.createObjectURL(file)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export type DownloadInput =
  | { url: string; name?: string }
  | { file: File }

export async function handleDownload(input: DownloadInput): Promise<void> {
  const name = 'file' in input ? input.file.name : (input.name ?? 'download')

  if ('file' in input) {
    const blobUrl = URL.createObjectURL(input.file)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = name
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
    return
  }

  try {
    await download(input.url, name)
  } catch {
    window.open(input.url, '_blank', 'noopener,noreferrer')
  }
}



